import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationPlaidExchangePublicTokenAtom = createMutationAtomFactory(
  'finance.plaidExchangePublicToken',
  (params: { publicToken: string }) => ({
    integrationsPlaidExchangePublicToken: {
      __args: {
        publicToken: params.publicToken,
      },
      itemId: true,
    },
  }),
);
